<template>
  <section role="main">
    <div class="main-container container container-top vale-page">
      <div v-if="!carregando && !habilitado" class="alert alert-warning mensagem-estado">
        <i class="fa fa-exclamation-triangle"></i>
        Você não atende aos critérios para realizar a escolha do vale-alimentação.
      </div>

      <div v-else-if="!carregando && !periodoAberto" class="alert alert-info mensagem-estado">
        <i class="fa fa-clock-o"></i>
        Aguarde o próximo período para escolha do vale-alimentação.
      </div>

      <template v-else-if="!carregando">
        <div class="row cabecalho-row">
          <div class="col-md-12 cabecalho-vale">
            <div class="titulo-vale">
              <div class="icone-titulo"><i class="fa fa-cutlery"></i></div>
              <div>
                <h4>Escolher Vale-Alimentação</h4>
                <span>Selecione a empresa de sua preferência.</span>
              </div>
            </div>
            <span :class="badgeClass" :title="badgeLabel">
              <i :class="badgeIcon"></i>
              <span>{{ badgeLabel }}</span>
            </span>
          </div>
        </div>

        <div class="row cards-resumo">
          <div class="col-md-4">
            <div class="card card-default card-info resumo-card">
              <div class="card-content d-flex-center">
                <span class="resumo-icone icone-verde"><i class="fa fa-calendar"></i></span>
                <div class="resumo-conteudo">
                  <small>Ano da competência</small>
                  <strong>{{ anoCompetencia }}</strong>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card card-default card-info resumo-card">
              <div class="card-content d-flex-center">
                <span class="resumo-icone" :style="{ color: statusColor }">
                  <i :class="statusIconClass"></i>
                </span>
                <div class="resumo-conteudo">
                  <small>Situação</small>
                  <strong :style="{ color: statusColor }">{{ statusLabel }}</strong>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card card-default card-info resumo-card">
              <div class="card-content d-flex-center">
                <span class="resumo-icone icone-verde"><i class="fa fa-calendar-check-o"></i></span>
                <div class="resumo-conteudo">
                  <small>Data da escolha</small>
                  <strong>{{ dataEscolhaFormatada }}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="card card-default escolha-card">
              <div class="card-content escolha-card-content">
                <div class="servidor-info">
                  <span class="servidor-icone"><i class="fa fa-user"></i></span>
                  <div class="servidor-dados">
                    <small>Nome do servidor</small>
                    <strong>{{ nomeServidor }}</strong>
                  </div>
                </div>

                <div class="mensagem-fixa">
                  <p><span class="destaque">Aviso:</span> A votação é obrigatória. O servidor deverá escolher uma das empresas disponíveis.</p>
                  <p class = "paragrafo">Caso não seja registrada nenhuma opção, será considerada automaticamente a empresa que obtiver o maior número de votos.</p>
                </div>
                <div v-if="!temEscolha && !modoEscolha" class="escolha-vazia">
                  <span class="escolha-vazia-icone"><i class="fa fa-cutlery"></i></span>
                  <div class="escolha-vazia-texto">
                    <h5>Nenhuma empresa selecionada</h5>
                    <p>Escolha uma das empresas credenciadas para concluir sua opção de vale-alimentação.</p>
                  </div>
                  <botao estilo="cheio-verde" icone="fa-check" rotulo="ESCOLHER EMPRESA" @clicado="iniciarEscolha"></botao>
                </div>

                <template v-else>
                  <div class="escolha-cabecalho">
                    <div>
                      <h5 class="titulo-escolha">{{ temEscolha ? 'Sua escolha' : 'Escolha sua empresa' }}</h5>
                      <p>{{ somenteConsulta ? 'Esta escolha está disponível somente para consulta.' : 'Selecione a empresa desejada e salve para confirmar.' }}</p>
                    </div>
                  </div>
                  <div class="lista-empresas">
                    <div
                      v-for="empresa in empresasExibidas"
                      :key="empresa.id"
                      class="empresa-item"
                      :class="classeItem(empresa.id)"
                    >
                      <div class="empresa-conteudo">
                        <label class="radio-inline radio-empresa">
                          <input
                            v-model="empresaSelecionada"
                            type="radio"
                            :value="empresa.id"
                            :disabled="somenteConsulta"
                          >
                          <span class="nome-empresa">{{ nomeDaEmpresa(empresa) }}</span>
                        </label>
                        <a
                            v-if="empresa.temMaterial !== false"
                            href="#"
                            class="link-detalhes"
                            @click.prevent="abrirAnexoEmNovaAba(empresa.id)"
                          >
                            <i class="fa fa-file-pdf-o"></i>
                            Material informativo
                            <i class="fa fa-external-link"></i>
                          </a>
                      </div>
                    </div>
                  </div>

                  <div class="actions-footer">
                    <botao
                      v-if="!somenteConsulta"
                      :estilo="podeSalvar ? 'vazado-verde' : 'vazado-cinza'"
                      icone="salvar"
                      rotulo="SALVAR"
                      :disabled="!podeSalvar || salvando"
                      @clicado="salvar"
                    ></botao>
                    <botao
                      v-if="temEscolha"
                      estilo="vazado-verde"
                      icone="fa-print"
                      rotulo="IMPRIMIR PROTOCOLO"
                      :disabled="imprimindo"
                      @clicado="imprimirProtocolo"
                    ></botao>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </section>
</template>

<script>
import Botao from '@/components/botao';
import ValeAlimentacaoService from '@/services/valeAlimentacaoService';
import ErrorHelper from '@/helpers/ErrorHelper';

export default {
  name: 'ValeAlimentacao',
  components: { Botao },
  data() {
    return {
      carregando: true,
      salvando: false,
      imprimindo: false,
      habilitado: false,
      periodoAberto: false,
      competencia: null,
      escolha: null,
      nomeServidor: '',
      empresas: [],
      empresaSelecionada: null,
      empresaOriginal: null,
      modoEscolha: false,
    };
  },
  computed: {
    temEscolha() {
      return Boolean(this.escolha && this.escolha.id);
    },
    tipoEscolha() {
      return this.temEscolha ? this.escolha.tipoEscolha : 'PENDENTE';
    },
    anoCompetencia() {
      return this.competencia ? this.competencia.ano : '—';
    },
    statusLabel() {
      const labels = {
        PENDENTE: 'PENDENTE',
        CONCLUIDA: 'CONCLUÍDA',
        FINALIZADA: 'FINALIZADA',
        ENVIADA: 'ENVIADA',
      };
      return labels[this.tipoEscolha] || '—';
    },
    badgeLabel() {
      if (!this.temEscolha) return this.statusLabel;
      if (this.escolha.nomeEmpresa) return this.escolha.nomeEmpresa;

      const empresa = this.empresas.find(item => item.id === this.empresaSelecionada);
      return empresa ? this.nomeDaEmpresa(empresa) : 'Empresa selecionada';
    },
    statusColor() {
      const cores = {
        PENDENTE: '#d98200',
        CONCLUIDA: '#238b45',
        FINALIZADA: '#2463a8',
        ENVIADA: '#2463a8',
      };
      return cores[this.tipoEscolha] || '#555';
    },
    badgeClass() {
      return `badge-status badge-${this.tipoEscolha.toLowerCase()}`;
    },
    badgeIcon() {
      if (this.tipoEscolha === 'PENDENTE') return 'fa fa-clock-o';
      if (this.tipoEscolha === 'CONCLUIDA') return 'fa fa-check-circle-o';
      return 'fa fa-lock';
    },
    statusIconClass() {
      return this.badgeIcon;
    },
    somenteConsulta() {
      return this.tipoEscolha === 'FINALIZADA' || this.tipoEscolha === 'ENVIADA';
    },
    podeSalvar() {
      if (this.somenteConsulta || !this.empresaSelecionada) return false;
      return !this.temEscolha || this.empresaSelecionada !== this.empresaOriginal;
    },
    dataFimLancamento() {
      return this.competencia != null ? this.competencia.dataLimiteLancamento : null;
    },
    dataEscolhaFormatada() {
      if (!this.temEscolha || !this.escolha.dataEscolha) return '—';
      const data = new Date(this.escolha.dataEscolha);
      if (isNaN(data.getTime())) return '—';
      return data.toLocaleString('pt-BR');
    },
    empresasExibidas() {
      if (!this.temEscolha || this.empresas.some(empresa => empresa.id === this.empresaSelecionada)) {
        return this.empresas;
      }
      return [{
        id: this.empresaSelecionada,
        nome: this.escolha.nomeEmpresa,
        temMaterial: false,
      }].concat(this.empresas);
    },
  },
  created() {
    this.carregar();
  },
  methods: {
    async carregar() {
      this.carregando = true;
      try {
        const contexto = await ValeAlimentacaoService.carregarContexto();
        this.habilitado = Boolean(contexto && contexto.habilitado);
        this.periodoAberto = Boolean(contexto && contexto.periodoAberto);
        this.competencia = contexto ? contexto.competencia : null;
        this.escolha = contexto ? contexto.escolha : null;
        this.nomeServidor = contexto && contexto.nomeServidor
          ? contexto.nomeServidor
          : this.$store.state.usuarioLogado.nome;

        if (this.escolha) {
          this.empresaSelecionada = this.escolha.idPessoaJuridicaValeAlimentacao;
          this.empresaOriginal = this.empresaSelecionada;
          this.modoEscolha = true;
        } else {
          this.empresaSelecionada = null;
          this.empresaOriginal = null;
          this.modoEscolha = false;
        }

        if (this.habilitado && this.periodoAberto) {
          this.empresas = await ValeAlimentacaoService.listaEmpresas();
        }
      } catch (error) {
        this.$root.$refs.toastr.e(ErrorHelper.trataMensagem(error), 'Atenção');
      } finally {
        this.carregando = false;
      }
    },
    iniciarEscolha() {
      this.modoEscolha = true;
    },
    nomeDaEmpresa(empresa) {
      if (empresa.nome) return empresa.nome;
      const pessoaJuridica = empresa.empresa || {};
      return pessoaJuridica.nomeFantasia || pessoaJuridica.nomeAbreviado || `Empresa ${empresa.id}`;
    },
    classeItem(idEmpresa) {
      if (this.empresaSelecionada !== idEmpresa) return '';
      return `selecionada ${this.tipoEscolha.toLowerCase()}`;
    },
    formataDataParaMensagem(data) {
      if (!data) return '—';

      const valor = String(data).trim();
      if (!valor) return '—';

      const partes = valor.split('-');
      if (partes.length !== 3) return valor;

      const [ano, mes, dia] = partes;
      if (!ano || !mes || !dia) return valor;

      return `${dia}/${mes}/${ano}`;
    },
    async salvar() {
          if (!this.podeSalvar) return;

          const dataLimite = this.dataFimLancamento;
          const dataFormatada = this.formataDataParaMensagem(dataLimite);
          const mensagens = [{
            id: 1,
            message: `ATENÇÃO: A escolha do vale-alimentação será encerrada em ${dataFormatada}. Após essa data, a opção escolhida só poderá ser alterada novamente após um ano.`,
            bold: false,
          }];

          this.$root.$refs.modal.confirm(mensagens, {
            title: 'Atenção',
            labelYes: 'OK',
            showNo: false,
            yes: async () => {
              this.salvando = true;
              try {
                const dados = {
                  idPessoaJuridicaValeAlimentacao: this.empresaSelecionada,
                  idMesCompetencia: this.competencia.id,
                };

                if (this.temEscolha) {
                  await ValeAlimentacaoService.atualiza(this.escolha.id, dados);
                } else {
                  await ValeAlimentacaoService.salvar(dados);
                }

                await this.carregar();
                this.$root.$refs.toastr.s('Escolha salva com sucesso!', 'Sucesso');
              } catch (error) {
                this.$root.$refs.toastr.e(ErrorHelper.trataMensagem(error), 'Erro ao salvar');
              } finally {
                this.salvando = false;
              }
            },
          });
        },
    async abrirAnexoEmNovaAba(id) {
      try {
        const arquivo = await ValeAlimentacaoService.visualizarAnexo(id);
        this.abrirPdf(arquivo);
      } catch (error) {
        this.$root.$refs.toastr.e('Não foi possível carregar o material informativo.', 'Atenção');
      }
    },
    async imprimirProtocolo() {
      if (!this.temEscolha) return;
      this.imprimindo = true;
      try {
        const arquivo = await ValeAlimentacaoService.imprimirProtocolo(this.escolha.id);
        this.abrirPdf(arquivo);
      } catch (error) {
        this.$root.$refs.toastr.e('Não foi possível gerar o protocolo.', 'Atenção');
      } finally {
        this.imprimindo = false;
      }
    },
    abrirPdf(arquivo) {
      const url = URL.createObjectURL(new Blob([arquivo], { type: 'application/pdf' }));
      window.open(url, '_blank');
      window.setTimeout(() => URL.revokeObjectURL(url), 60000);
    },
  },
};
</script>

<style scoped>
.vale-page {
  padding-top: 28px;
  padding-bottom: 48px;
}

.cabecalho-row {
  margin-bottom: 24px;
}

.cabecalho-vale {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
}

.titulo-vale {
  display: flex;
  align-items: center;
  min-width: 0;
}

.icone-titulo {
  display: flex;
  flex: 0 0 52px;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  margin-right: 16px;
  border-radius: 50%;
  background: #277e5e;
  box-shadow: 0 5px 14px rgba(39, 126, 94, .2);
  color: #fff;
  font-size: 22px;
}

.titulo-vale h4 {
  margin: 0 0 5px;
  color: #263b37;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.25;
}

.titulo-vale span {
  color: #71807d;
  font-size: 14px;
  line-height: 1.4;
}

.badge-status {
  display: inline-flex;
  flex: 0 1 auto;
  align-items: center;
  max-width: 42%;
  min-height: 40px;
  padding: 9px 16px;
  border: 1px solid;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.25;
}

.badge-status i {
  flex: 0 0 auto;
  margin-right: 8px;
  font-size: 17px;
}

.badge-status span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.badge-pendente { color: #b96c00; border-color: #f2d39b; background: #fff6e6; }
.badge-concluida { color: #237a40; border-color: #cce8d2; background: #ebf8ed; }
.badge-finalizada,
.badge-enviada { color: #245f9f; border-color: #cadcf1; background: #edf4fc; }

.cards-resumo {
  margin-bottom: 8px;
}

.resumo-card {
  min-height: 96px;
  margin-bottom: 20px;
  border-color: #dde5e3;
  box-shadow: 0 3px 10px rgba(27, 63, 54, .06);
}

.resumo-card .card-content {
  min-height: 94px;
  padding: 20px 22px;
}

.d-flex-center {
  display: flex;
  align-items: center;
}

.resumo-icone {
  display: flex;
  flex: 0 0 44px;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin-right: 15px;
  border-radius: 10px;
  background: #f0f6f4;
  font-size: 21px;
}

.icone-verde { color: #277e5e; }
.resumo-conteudo { min-width: 0; }

.resumo-card small,
.servidor-info small {
  display: block;
  margin-bottom: 5px;
  color: #7e8c89;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: .35px;
  line-height: 1.2;
  text-transform: uppercase;
}

.resumo-card strong,
.servidor-info strong {
  display: block;
  overflow: hidden;
  color: #2d3d3a;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.escolha-card {
  border-color: #d9e2e0;
  box-shadow: 0 5px 18px rgba(27, 63, 54, .08);
}

.escolha-card-content {
  padding: 0;
}

.servidor-info {
  display: flex;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e5eae9;
  background: #fbfcfc;
}

.servidor-icone {
  display: flex;
  flex: 0 0 38px;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  margin-right: 13px;
  border-radius: 50%;
  background: #eef3f2;
  color: #5c6d69;
  font-size: 16px;
}

.servidor-dados { min-width: 0; }

.escolha-vazia {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 28px 24px;
}

.escolha-vazia-icone {
  display: flex;
  flex: 0 0 50px;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 12px;
  background: #edf6f2;
  color: #277e5e;
  font-size: 21px;
}

.escolha-vazia-texto {
  flex: 1 1 auto;
  min-width: 0;
}

.escolha-vazia h5,
.titulo-escolha {
  margin: 0 0 6px;
  color: #176348;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
}

.escolha-vazia p,
.escolha-cabecalho p {
  margin: 0;
  color: #73817e;
  font-size: 13px;
  line-height: 1.5;
}

.escolha-cabecalho {
  padding: 22px 24px 16px;
}

.lista-empresas {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 24px;
}

.empresa-item {
  border: 1px solid #e1e8e6;
  border-radius: 7px;
  background: #fff;
  transition: border-color .15s ease, background-color .15s ease, box-shadow .15s ease;
}

.empresa-item:hover {
  border-color: #b8d1ca;
  box-shadow: 0 2px 7px rgba(32, 91, 70, .06);
}

.empresa-item.selecionada {
  border-color: #83b69f;
  box-shadow: inset 3px 0 0 #277e5e;
}

.empresa-item.selecionada.pendente { background: #fffaf0; }
.empresa-item.selecionada.concluida { background: #f0f9f3; }
.empresa-item.selecionada.finalizada,
.empresa-item.selecionada.enviada { border-color: #a9c5e2; background: #f1f6fc; box-shadow: inset 3px 0 0 #2463a8; }

.empresa-conteudo {
  display: flex;
  align-items: center;
  min-height: 54px;
  padding: 10px 14px;
}

.radio-empresa {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  min-width: 0;
  margin: 0;
  padding-left: 0;
  position: static;
  cursor: pointer;
  font-weight: normal;
}

.radio-empresa input[type='radio'] {
  position: static;
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  margin: 0 12px 0 0;
}

.nome-empresa {
  overflow: hidden;
  color: #31413e;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.link-detalhes {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  margin-left: 20px;
  padding: 7px 9px;
  border-radius: 5px;
  color: #277e5e;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.link-detalhes:hover,
.link-detalhes:focus {
  background: #e8f3ef;
  color: #176348;
}

.link-detalhes .fa-file-pdf-o { margin-right: 7px; }
.link-detalhes .fa-external-link { margin-left: 7px; }

.actions-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding: 20px 24px 24px;
  border-top: 1px solid #e5eae9;
  background: #fbfcfc;
}

.actions-footer .btn {
  min-width: 170px;
  min-height: 40px;
}

.mensagem-estado {
  display: flex;
  align-items: center;
  min-height: 72px;
  margin-top: 20px;
  padding: 20px 22px;
  border-radius: 8px;
  font-size: 15px;
  line-height: 1.45;
}

.mensagem-estado i {
  margin-right: 12px;
  font-size: 20px;
}

.mensagem-fixa {
  margin-left:22px;
  font-size:17px;
  padding: 0;
}

.mensagem-fixa .paragrafo {
  margin-left:50px;
}

.mensagem-fixa .destaque {
  color: #176348;
  font-weight: bolder;
}
@media (max-width: 991px) {
  .badge-status { max-width: 48%; }
  .resumo-card { min-height: 88px; }
  .resumo-card .card-content { min-height: 86px; padding: 17px 18px; }
  .resumo-icone { flex-basis: 38px; width: 38px; height: 38px; margin-right: 12px; font-size: 18px; }
  .resumo-card strong { font-size: 14px; }
}

@media (max-width: 767px) {
  .vale-page { padding-top: 20px; padding-bottom: 28px; }
  .cabecalho-row { margin-bottom: 18px; }
  .cabecalho-vale { align-items: flex-start; gap: 14px; }
  .icone-titulo { flex-basis: 44px; width: 44px; height: 44px; margin-right: 12px; font-size: 19px; }
  .titulo-vale h4 { font-size: 17px; }
  .titulo-vale span { font-size: 12px; }
  .badge-status { max-width: 44%; min-height: 34px; padding: 7px 11px; font-size: 11px; }
  .badge-status i { font-size: 14px; }
  .resumo-card { min-height: auto; margin-bottom: 12px; }
  .resumo-card .card-content { min-height: 78px; }
  .servidor-info { padding: 17px 18px; }
  .escolha-vazia { align-items: flex-start; flex-wrap: wrap; padding: 22px 18px; }
  .escolha-vazia-texto { flex-basis: calc(100% - 68px); }
  .escolha-vazia .btn { width: 100%; margin-top: 4px; }
  .escolha-cabecalho { padding: 20px 18px 14px; }
  .lista-empresas { gap: 9px; padding: 0 18px; }
  .empresa-conteudo { align-items: flex-start; flex-wrap: wrap; padding: 12px; }
  .radio-empresa { min-height: 30px; }
  .nome-empresa { white-space: normal; }
  .link-detalhes { margin: 5px 0 0 27px; }
  .actions-footer { flex-direction: column; gap: 10px; margin-top: 20px; padding: 18px; }
  .actions-footer .btn { width: 100%; min-width: 0; margin: 0; }
}

@media (max-width: 480px) {
  .cabecalho-vale { flex-direction: column; }
  .badge-status { align-self: flex-start; max-width: 100%; margin-left: 56px; }
  .badge-status span { white-space: normal; }
  .escolha-vazia-icone { display: none; }
  .escolha-vazia-texto { flex-basis: 100%; }
}
</style>



// WEBPACK FOOTER //
// index.vue?2ad40ec3